// Blog Posts Listing Component Scripts using Alpine.js

import { Alpine } from '@webikon/webentor-core/_alpine';

interface BlogPostsListingData {
  orderByFieldSelector: string;
  $el?: HTMLElement;
  init(): void;
  handlePostsOrderBy(value: string): void;
}

export default function blogPostsListing(): BlogPostsListingData {
  return {
    orderByFieldSelector: '',

    init() {
      // Get field selector from data attribute
      const container = this.$el as HTMLElement;
      this.orderByFieldSelector = container.dataset.orderByField || 'order_by';
    },

    handlePostsOrderBy(value: string) {
      if (!value) return;

      try {
        const url = new URL(window.location.href);
        url.searchParams.set(this.orderByFieldSelector, value);
        url.searchParams.delete('paged'); // Reset pagination when changing order
        window.location.href = url.toString();
      } catch (error) {
        console.error('Error updating URL parameters:', error);
      }
    },
  };
}

// Register Alpine component
Alpine.data('blogPostsListing', blogPostsListing);
